import React from 'react';
import { connect } from 'react-redux';

import { Modal } from 'redpoints-front-components/index';

import { auditResultsCreateIncidents } from '../../../actions/auditResultsActions';
import { getAuditResultsAppliedAuditorAssetId } from '../../../reducers/assetAudit/auditResults';
import { translate } from '../../../helpers/languageHelper';

const ModalContent = () => (
  <div>
    <p>
      {translate(
        'auditResults.modals.createIncidents.missingLinksWillBeCreated'
      )}
    </p>
    <p>
      {translate(
        'auditResults.modals.createIncidents.actionMayTakeTimeAndMinutesToSeeResults'
      )}
    </p>
    <p>{translate('common.doYouWantToContinue')}</p>
  </div>
);

const AuditResultsCreateIncidentsModal = ({
  auditAssetId,
  auditResultsCreateIncidents,
  closeModal,
  visible,
}) => {
  const handleOnOk = () => {
    auditResultsCreateIncidents({ auditAssetId });
    closeModal();
  };

  const handleOnCancel = () => {
    closeModal();
  };

  return (
    <Modal
      cancelText={translate('actions.cancel')}
      closable={false}
      okText={translate('auditResults.modals.createIncidents.buttons.accept')}
      onCancel={handleOnCancel}
      onOk={handleOnOk}
      title={translate('auditResults.modals.createIncidents.title')}
      visible={visible}
    >
      <ModalContent />
    </Modal>
  );
};

const mapStateToProps = state => ({
  auditAssetId: getAuditResultsAppliedAuditorAssetId(state),
});

export default connect(mapStateToProps, { auditResultsCreateIncidents })(
  AuditResultsCreateIncidentsModal
);
